module.exports = __webpack_public_path__ + "static/img/desktop_bkg.843be094.png";